import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import * as styles from './EventsSection.module.scss';
import Event from './Event';
import { useTranslation } from 'react-i18next';

interface EventsSectionProps {
  greenBackground?: boolean;
}

const EventsSection = ({ greenBackground = false }: EventsSectionProps): React.ReactElement => {
  const { t } = useTranslation();
  const data: any = useStaticQuery(
    graphql`
      {
        sanityHomepage {
          events {
            title
            startDate
            endDate
            location
          }
        }
      }
    `,
  );
  const homepage = data.sanityHomepage || {};

  return (
    <section
      className={
        styles.section + ' ' + (greenBackground ? styles.greenBackground : styles.sectionBackground)
      }
    >
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>{t('event_section.title', 'Next events')}</h2>
        <div className={styles.content}>
          {homepage.events.map((event: any, i: number) => (
            <Event
              key={i}
              startDate={event.startDate}
              endDate={event.endDate}
              title={event.title}
              location={event.location}
            ></Event>
          ))}
          {Array.from({ length: (3 - (homepage.events.length % 3)) % 3 }).map((__, i: number) => (
            <div key={i} className={styles.mockEvent}></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
